import React from "react"
import App from "./App.js"
import store from "./store.js"
import reportWebVitals from "./reportWebVitals.js"
import { Provider } from "react-redux"
import { createRoot } from "react-dom/client"
import "react-app-polyfill/stable.js"
import "core-js"

createRoot(document.getElementById("root")).render(
  <Provider store={store}><App /></Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
